import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FaEdit } from 'react-icons/fa';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import translate from 'containers/translate';
import PeriodEdit from 'components/periodEdit/PeriodEdit';
import Tooltip from 'components/tooltip/Tooltip';
import { consumesDossier } from 'contexts/DossierContext';
import { consumesPeriods } from 'contexts/PeriodsContext';
import './AdminPeriodEdit.scss';

class AdminPeriodEdit extends Component {
  constructor(props) {
    super(props);
    this.state = { showEditDialog: false, showSaveErrorModal: false, saveErrorDocumentIds: [] };
    this.onDialogDismiss = this.onDialogDismiss.bind(this);
    this.onDialogSave = this.onDialogSave.bind(this);
    this.onSaveErrorDismiss = this.onSaveErrorDismiss.bind(this);
    this.periodEditSubmitRef = React.createRef();
  }

  render() {
    const { t } = this.props;

    return (
      <div className="AdminPeriodEdit">
        {this.renderAdminPeriodDialog()}
        {this.renderSaveErrorModal()}
        <Tooltip title={t('admin_period_edit_icon_tooltip')}>
          <span className="period-edit-icon" onClick={() => this.setState({ showEditDialog: true })}>
            <FaEdit />
          </span>
        </Tooltip>
      </div>
    );
  }

  renderAdminPeriodDialog() {
    const { t } = this.props;

    if (!this.state.showEditDialog) {
      return null;
    }

    return (
      <Modal isOpen className="AdminPeriodEditModal" size="lg" toggle={this.onDialogDismiss}>
        <ModalHeader toggle={this.onDialogDismiss}>{t('admin_period_edit')}</ModalHeader>
        <ModalBody>
          <div className={'editMask'}>
            <PeriodEdit autoSubmit={false} submitRef={this.periodEditSubmitRef} />
          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onDialogSave}>
            {t('save')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  renderSaveErrorModal() {
    const { t, dossier, selectedPeriod } = this.props;

    if (!this.state.showSaveErrorModal) {
      return null;
    }

    return (
      <Modal isOpen className="AdminPeriodEditSaveErrorModal" toggle={this.onSaveErrorDismiss}>
        <ModalHeader toggle={this.onSaveErrorDismiss}>{t('period_end_date_save_error_title')}</ModalHeader>
        <ModalBody>
          <p>{t('period_end_date_save_error_body')}</p>
          {this.state.saveErrorDocumentIds.length > 0 && (
            <p className="saveErrorDocumentLinks">
              {this.state.saveErrorDocumentIds.map((documentId, index) => (
                <span key={documentId}>
                  {index > 0 ? ', ' : ''}
                  <a
                    href={`/dossier/${dossier.id}/${selectedPeriod.id}/edit/${documentId}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {documentId}
                  </a>
                </span>
              ))}
            </p>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={this.onSaveErrorDismiss}>
            {t('close')}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  onDialogDismiss() {
    this.setState({ showEditDialog: false });
  }

  onDialogSave() {
    if (!this.periodEditSubmitRef.current) {
      this.setState({ showEditDialog: false });
      return;
    }

    this.periodEditSubmitRef.current((err) => {
      if (err) {
        const documentIds = err.response?.data?.details?.documentIds || [];
        this.setState({ showSaveErrorModal: true, saveErrorDocumentIds: documentIds });
        return;
      }
      this.setState({ showEditDialog: false });
    });
  }

  onSaveErrorDismiss() {
    this.setState({ showSaveErrorModal: false });
  }
}

AdminPeriodEdit.propTypes = {
  t: PropTypes.func.isRequired,
  dossier: PropTypes.object,
  selectedPeriod: PropTypes.object,
};

export default consumesDossier(consumesPeriods(translate(AdminPeriodEdit)));
